import { createAction } from '@reduxjs/toolkit';
import { getPayloadCreator } from 'app-components/flux/core/actionHelpers';
import type {
  HistoricalBalancePayloadType,
  ImportDataPayloadType,
  MultiAccountPayloadType,
  PfmImportPayloadType,
} from './importTypes';

const parsePostPayloadCreator = getPayloadCreator<string>();
const importDataPayloadCreator = getPayloadCreator<ImportDataPayloadType>();
const historicalBalancesPayloadCreator = getPayloadCreator<HistoricalBalancePayloadType>();
const pfmImportPayloadCreator = getPayloadCreator<PfmImportPayloadType>();
const multiAccountImportPayloadCreator = getPayloadCreator<MultiAccountPayloadType>();

export const importData = createAction('IMPORT_DATA', importDataPayloadCreator);
export const importDataSuccess = createAction('IMPORT_DATA_SUCCESS');
export const importDataFailure = createAction('IMPORT_DATA_FAILURE');

export const pfmImport = createAction('PFM_IMPORT', pfmImportPayloadCreator);
export const pfmImportSuccess = createAction('PFM_IMPORT_SUCCESS');
export const pfmImportFailure = createAction('PFM_IMPORT_FAILURE');

export const pfmImportParsePost = createAction('PFM_IMPORT_PARSE', parsePostPayloadCreator);
export const pfmImportParsePostSuccess = createAction('PFM_IMPORT_PARSE_SUCCESS');
export const pfmImportParsePostFailure = createAction('PFM_IMPORT_PARSE_FAILURE');

export const pfmImportMultiAccountImport = createAction('PFM_IMPORT_MULTI_ACCOUNT', multiAccountImportPayloadCreator);
export const pfmImportMultiAccountImportSuccess = createAction('PFM_IMPORT_MULTI_ACCOUNT_SUCCESS', getPayloadCreator());
export const pfmImportMultiAccountImportFailure = createAction('PFM_IMPORT_MULTI_ACCOUNT_FAILURE');

export const pfmImportHistoricalBalancesImport = createAction(
  'PFM_IMPORT_HISTORICAL_BALANCES',
  historicalBalancesPayloadCreator,
);
export const pfmImportHistoricalBalancesImportSuccess = createAction(
  'PFM_IMPORT_HISTORICAL_BALANCES_SUCCESS',
  getPayloadCreator(),
);
export const pfmImportHistoricalBalancesImportFailure = createAction('PFM_IMPORT_HISTORICAL_BALANCES_FAILURE');

export const pfmImportMintPromoExtend = createAction('PFM_IMPORT_MINT_PROMO_EXTEND', getPayloadCreator());
export const pfmImportMintPromoExtendSuccess = createAction(
  'PFM_IMPORT_MINT_PROMO_EXTEND_SUCCESS',
  getPayloadCreator(),
);
export const pfmImportMintPromoExtendFailure = createAction(
  'PFM_IMPORT_MINT_PROMO_EXTEND_FAILURE',
  getPayloadCreator(),
);
